export const ENV = {
    API_URL: process.env.REACT_APP_API_URL,
    SERVER_URL: process.env.REACT_APP_SERVER_URL,
    COUNTRY: process.env.REACT_APP_COUNTRY,
    PORT: process.env.REACT_APP_PORT,
};
